const kProductIdRegex = /^[0-9]*$/;
/**
 * Gets the product ID with Okendo formatting.
 * @param productId The Shopify Product ID e.g. gid://shopify/Product/10079785100.
 * @returns The product ID in Okendo formatting.
 */
export function getOkendoProductId(productId) {
    if (!productId) {
        return;
    }
    // Supports Shopify's GraphQL Id syntax e.g. gid://shopify/Product/10079785100
    return `shopify-${kProductIdRegex.test(productId)
        ? productId
        : productId.split('/').slice(-1)[0]}`;
}
